import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { CompanyReportSection } from '@nk/data-entities-lib';

export const REPORT_ENTITIES_LIMIT = 100;

export interface ReportSectionOption {
  key: CompanyReportSection;
  labelKey: string;
  checked: boolean;
}

export const ALL_COMPANY_REPORT_SECTION_KEYS: CompanyReportSection[] = [
  'employments',
  'risk',
  'flags',
  'events',
  'legal_rights',
  'roles',
  'ownership',
  'merger_demerger',
  'collateral',
  'mortgaged_movable_property',
  'property',
  'accounts',
  'payment_remarks',
];

export const DEFAULT_COMPANY_REPORT_SECTIONS: ReportSectionOption[] = [
  { key: 'employments', labelKey: extractTranslation('company.report_options.employments'), checked: false },
  { key: 'risk', labelKey: extractTranslation('company.report_options.risk'), checked: false },
  { key: 'flags', labelKey: extractTranslation('company.report_options.flags'), checked: false },
  { key: 'events', labelKey: extractTranslation('company.report_options.events'), checked: false },
  { key: 'legal_rights', labelKey: extractTranslation('company.report_options.legal_rights'), checked: false },
  { key: 'roles', labelKey: extractTranslation('company.report_options.roles'), checked: false },
  { key: 'ownership', labelKey: extractTranslation('company.report_options.ownership'), checked: false },
  { key: 'merger_demerger', labelKey: extractTranslation('company.report_options.merger_demerger'), checked: false },
  { key: 'collateral', labelKey: extractTranslation('company.report_options.collateral'), checked: false },
  {
    key: 'mortgaged_movable_property',
    labelKey: extractTranslation('company.report_options.mortgaged_movable_property'),
    checked: false,
  },
  { key: 'property', labelKey: extractTranslation('company.report_options.property'), checked: false },
  { key: 'accounts', labelKey: extractTranslation('company.report_options.accounts'), checked: false },
];
